import {Heading} from '@smart/web-components';
import * as React from 'react';
import styles from './price.module.scss';

export interface PriceProps {
  readonly value: string | undefined;
  readonly loading: boolean;
}

export function Price({value, loading}: PriceProps): JSX.Element {
  return (
    <Heading
      variant="display-emotional-300"
      tag="div"
      className={loading ? styles.loading : undefined}
    >
      {value ?? <>&nbsp;</>}
    </Heading>
  );
}
